import React, { Component } from "react";

export default class MyLeaveDetail extends Component {
  get totalLeaveTaken() {
    return this.props.leaveBalanceDetails.reduce(
      (prev, curr, _, __) => curr.taken + prev,
      0
    );
  }

  get totalLeaveAvailable() {
    return this.props.leaveBalanceDetails.reduce(
      (prev, curr, _, __) => curr.total + prev,
      0
    );
  }

  render() {
    if (this.props.leaveBalanceDetails.length === 0) return null;
    return (
      <div className="col-sm-4 white-bg mt20 border-class">
        <div className="form-group" style={{ marginTop: 20 }}>
          <h4>My Leave Details</h4>
          <hr />
          {this.props.leaveBalanceDetails.map((detail) => {
            return (
              <div className="row mt20">
                <div className="col-sm-8">{detail.leave_category}:</div>
                <div className="col-sm-4">
                  {detail.taken}/{detail.total}
                </div>
              </div>
            );
          })}
          <div className="row mt20">
            <div className="col-sm-8">Total:</div>
            <div className="col-sm-4">
              {this.totalLeaveTaken}/{this.totalLeaveAvailable}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
